import { useState, useRef, useEffect } from 'react';
import ArrowLeftIcon from '../../images/arrow-left.svg';
import NewChatIcon from '../../images/new-chat.svg';
import { useNavigate } from 'react-router-dom';
import { getBotMetadata } from '../helpers';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { forkPrompts } from '../helpers';
import { useUserState } from './UserStateProvider';

const Topbar = ({ title, forkPrompt, onForkPromptChange, backButton, onClearChat, onCollapse, collapsed }) => {
    const [forkPromptSelectOpen, setForkPromptSelectOpen] = useState(false);

    const { appVersion } = useUserState();

    const navigate = useNavigate();

    const customSelectRef = useRef(null);

    const handleForkPromptSelectToggle = e => {
        e.stopPropagation();
        setForkPromptSelectOpen(prevState => !prevState);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (customSelectRef.current && !customSelectRef.current.contains(event.target)) {
                setForkPromptSelectOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [customSelectRef]);

    useEffect(() => {
        setForkPromptSelectOpen(false);

        if (forkPrompt) {
            localStorage.setItem('assistant_type', forkPrompt);
        }
    }, [forkPrompt]);

    return (
        <div className={`topbar tif-bg-color-white position-sticky tif-w-100 top-0 ${forkPrompt ? 'has-strip' : ''}`}>
            {
                forkPrompt &&
                <div className={`currently-viewing-strip d-flex justify-content-md-between justify-content-center align-items-center flex-nowrap tif-color-white tif-py-5 tif-pr-55 tif-pl-65 ${forkPrompt}`}>
                    {/* <p className="tif-mb-0 d-md-block d-none"><strong>Currently Viewing: {getBotMetadata(forkPrompt, "viewingLabel").name}</strong> <i>({getBotMetadata(forkPrompt, "viewingLabel").message})</i></p> */}
                    <p className="tif-mb-0 text-md-end text-center">Version {appVersion} <a href="mailto:hosting@thinkitfirst.com" className="tif-color-white">Need help or have questions?</a></p>
                </div>
            }
            <div className={`d-flex justify-content-between align-items-center tif-py-md-15 tif-py-10 tif-pr-md-55 tif-px-30 tif-pl-${backButton ? '-md-25' : '-md-65'}`}>
                <div className="topbar-heading align-items-center d-flex">
                    {
                        backButton &&
                        <button className="back-btn tif-color-zulu bg-transparent border-0 tif-p-0" onClick={() => navigate(-1)}><img src={ArrowLeftIcon} className="align-baseline tif-mr-10" alt="Arrow left icon" />Back</button>
                    }
                    <h1 className="tif-h3 tif-mb-0">{title}</h1>
                </div>
                {
                    forkPrompt &&
                    <div className="topbar-btn-group d-flex">
                        <OverlayTrigger overlay={<Tooltip id="new-chat">New Chat</Tooltip>} placement="bottom">
                            <button className="btn-group-btn border-0" onClick={() => onClearChat(forkPrompt)}><img src={NewChatIcon} alt="New chat icon" /></button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip id="close-thinking-log">{collapsed ? 'Open' : 'Close'} Thinking Log</Tooltip>} placement="bottom">
                            <button className="btn-group-btn thinking-log-btn border-0 d-xl-block d-none" onClick={() => onCollapse(prev => !prev)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 18 18" fill="none" stroke="#24439c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="1" y="1" width="16" height="16" rx="2" />
                                    <path d="M12 1 L15 1 Q17 1 17 3 L17 15 Q17 17 15 17 L12 17 Z" fill="#24439c" stroke="none" />
                                    <polyline points="7 7 9 9 7 11" />
                                </svg>
                            </button>
                        </OverlayTrigger>
                        {/* <div className={`custom-select tif-ml-25 ${forkPromptSelectOpen ? 'show' : ''}`} ref={customSelectRef}>
                                <button onClick={handleForkPromptSelectToggle}>{forkPrompts[forkPrompt]}</button>
                                <div className="menu-wrapper">
                                    <ul>
                                        {
                                            Object.keys(forkPrompts).map((key, index) => (
                                                <li key={index} className={forkPrompt === key ? 'active' : ''} onClick={() => onForkPromptChange(key)}>{forkPrompts[key]}</li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div> */}
                    </div>
                }
            </div>
        </div>
    );
};

export default Topbar;